// Shared category taxonomy used across Material Quotes, Submittals, and the
// Material Database so they all stay in sync. Add a category here once and it
// shows up everywhere.
export const MATERIAL_QUOTE_CATEGORIES = [
  'Pipe', 'Wire', 'Fiber', 'Sand / Base', 'Poles', 'Gear',
  'Controls / SCADA', 'Concrete', 'Signal Heads', 'RRFBs', 'Equipment',
];

export const SUB_QUOTE_CATEGORIES = [
  'Paving', 'Concrete', 'Traffic Control', 'Fiber Splicing',
  'Integration', 'Saw Cutting',
];

// Material items first, then sub items, deduped. Used by the Submittals dropdown
// and the Material Database.
export const ALL_CATEGORIES = Array.from(new Set([...MATERIAL_QUOTE_CATEGORIES, ...SUB_QUOTE_CATEGORIES]));
